// App
export const APP_SET_SHOW_SETTINGS_STATE = 'APP_SET_SHOW_SETTINGS_STATE'
export const APP_SET_SHOW_LOGIN_STATE = 'APP_SET_SHOW_LOGIN_STATE'
export const APP_SET_AUTOLAUNCH_ENABLED_STATE = 'APP_SET_AUTOLAUNCH_ENABLED_STATE'

// Users
export const USERS_READ_FROM_FORAGE = 'USERS_READ_FROM_FORAGE'
export const USERS_FORGET_USERS = 'USERS_FORGET_USERS'
export const USERS_LOGIN_USER = 'USERS_LOGIN_USER'
export const USERS_LOGOUT_USER = 'USERS_LOGOUT_USER'
export const USERS_SET_USER_PINNED_STATE = 'USERS_SET_USER_PINNED_STATE'
export const USERS_SET_USER_MULTILAUNCH_STATE = 'USERS_SET_USER_MULTILAUNCH_STATE'
export const USERS_SET_USER_ACCESSTOKEN = 'USERS_SET_USER_ACCESSTOKEN'
export const USERS_SET_USER_PROFILE = 'USERS_SET_USER_PROFILE'
export const USERS_SET_AUTOLAUNCH = 'USERS_SET_AUTOLAUNCH'
export const USER_SET_ORDER = 'USER_SET_ORDER'

// Launcher
export const LAUNCHER_UPDATE_READY_STATE = 'LAUNCHER_UPDATE_READY_STATE'

// Versions
export const VERSIONS_SET_CLIENT = 'VERSIONS_SET_CLIENT'
export const VERSIONS_SET_LAUNCHER = 'VERSIONS_SET_LAUNCHER'
export const VERSIONS_SET_UI = 'VERSIONS_SET_UI'

// Steam
export const STEAM_UPDATE = 'STEAM_UPDATE'
export const STEAM_SET_USED_TICKET = 'STEAM_SET_USED_TICKET'

// Servers
export const SERVERS_UPDATE_ACTIVE = 'SERVERS_UPDATE_ACTIVE'
export const SERVERS_UPDATE_SERVERLIST = 'SERVERS_UPDATE_SERVERLIST'
export const SERVERS_SET_SERVER_STATUS = 'SERVERS_SET_SERVER_STATUS'
export const SERVERS_SET_ENABLED_LIST = 'SERVERS_SET_ENABLED_LIST'
export const SERVERS_SET_PROFILES = 'SERVERS_SET_PROFILES'

// Process
export const PROCESS_UPDATE = 'PROCESS_UPDATE'
export const PROCESS_SET_PROGRESS = 'PROCESS_SET_PROGRESS'

// Sync
export const SYNC_UPDATE_NEWS_HASH = 'SYNC_UPDATE_NEWS_HASH'
export const SYNC_UPDATE_ADS_TIMESTAMP = 'SYNC_UPDATE_ADS_TIMESTAMP'
export const SYNC_UPDATE_TWITCH_STATUS = 'SYNC_UPDATE_TWITCH_STATUS'
export const SYNC_UPDATE_BACKGROUND = 'SYNC_UPDATE_BACKGROUND'
export const SYNC_UPDATE_VERSIONS = 'SYNC_UPDATE_VERSIONS'
export const SYNC_UPDATE_HASH = 'SYNC_UPDATE_HASH'

// Profile
export const PROFILE_SHOW_SELECTOR = 'PROFILE_SHOW_SELECTOR'
export const PROFILE_HIDE_SELECTOR = 'PROFILE_HIDE_SELECTOR'

// Logger
export const LOGGER_LOG = 'LOGGER_LOG'



// WEBPACK FOOTER //
// ./src/constants/index.js